package com.xtream.data_kmp.dto



import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class Ad(
    @SerialName("action")
    val action: String?,
    @SerialName("aspect")
    val aspect: Aspect?,
    @SerialName("banner_type")
    val bannerType: String?,
    @SerialName("created_at")
    val createdAt: String?,
    @SerialName("description")
    val description: Title?,
    @SerialName("discount_new_price")
    val discountNewPrice: String?,
    @SerialName("discount_old_price")
    val oldPrice: String?,
    @SerialName("id")
    val id: Int?,
    @SerialName("image_en")
    val imageEn: String?,
    @SerialName("image_ar")
    val imageAr: String?,
    @SerialName("image_ku_sor")
    val imageKuSor: String?,
    @SerialName("image_ku_kur")
    val imageKuKor: String?,
    @SerialName("title")
    val title: Title?,
    @SerialName("updated_at")
    val updatedAt: String?
) {

    fun localizedImage(locale: String): String? {
      //  Log.d("Ad", "localize: $locale")

        return when (locale) {
            "ar" -> imageAr
            "kmr" -> imageKuKor
            "ckb" -> imageKuSor
            else -> imageEn

        }}


    
    @Serializable
    data class Aspect(
        @SerialName("denominator")
        val denominator: Float=16f,
        @SerialName("numerator")
        val numerator: Float=9f
    )



    
    @Serializable
    data class Title(
        @SerialName("ar")
        val ar: String?,
        @SerialName("en")
        val en: String?,
        @SerialName("ku_kur")
        val kuKur: String?,
        @SerialName("ku_sor")
        val kuSor: String?
    ){
        fun localize(locale: String): String? {
          //  Log.d("Ad", "localize: $locale")

            return when (locale) {
                "ar" -> ar
                "kmr" -> kuKur
                "ckb" -> kuSor
                else -> en

            }}
    }
}